import React from 'react';
import { tscope } from '@i18n';
import { Identity } from '@assets/images';
import {
  Card,
  Divider,
} from 'ui';
import {
  DOCUMENT_TYPES,
  DocumentSection,
  UploadFormContainer,
} from '../components';
import { useController } from './hooks';

const ts = tscope('Documents.identificationContent');

const type = DOCUMENT_TYPES.ID_CARD;

export const UploadIdentification = () => {
  const {
    control,
    isLoading,
    clearField,
    onUploadError,
    idRearDocument,
    idFrontDocument,
    areDocumentsReady,
    onRemoveCompleted,
    onUploadCompleted,
  } = useController();

  return (
    <UploadFormContainer
      t={ts}
      imageElement={<Identity width="100%" height="100%" data-testid="image" />}
      type={type}
      areDocumentsReady={areDocumentsReady}
    >
      <Card>
        <DocumentSection
          t={ts}
          name="idFront"
          filesCount={1}
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          document={idFrontDocument}
          onUploadError={onUploadError}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
        />
        <Divider />
        <DocumentSection
          t={ts}
          name="idRear"
          filesCount={1}
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          document={idRearDocument}
          onUploadError={onUploadError}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
        />
      </Card>
    </UploadFormContainer>
  );
};
